import React from 'react';
import WarrantyDialogue from '../../../WarrantyDialogue';

import Pic1 from '../../InstallImages/ACDCLogo';


const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <p className="specsText">

                Solvana has access to the best and most bankable solar equipment and components on the market. We have direct relationships with manufacturers and trusted distributors. Collaborating with our equipment suppliers, staying up to date on the latest technological improvements, and receiving the best pricing, are some of the ways Solvana provides you with the best value in the solar industry. Before designing your system and selecting the ideal combination of equipment and engineering, we consider many factors, including shading, roof azimuths, structural, and electrical consumption loads for system sizing and energy storage calculations. As you well know, equipment and components are not all created equally, but you don’t have to worry about those details since we have your back. Solvana has over two decades of combined experience in the solar sector, and we know which modules, inverters, racking, flashing, and batteries are reliable and best suited for your particular application. So, you can enjoy the peace-of-mind that your solar-generating system provides along with the many years of safe energy production. Solvana warrants all installation work to be free from defects in workmanship for 10-years from the project’s completion date. This warranty is in conjunction with the manufacturer’s warranties and does not replace them.

            </p>
            <p className="specsText">
                <WarrantyDialogue />
            </p>
        </div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
    </div>
);

export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/MISC/WGYB.js